import { environment as env } from './environment.default'

// local demo build for the Turin city profile : same neutral (non ACTV) context as
// environment.demolocal, but demoCity = 'torino' so the map, the brand and the datasets
// switch to Turin. Unlike the Lisbon build, this one starts in ITALIAN : the frontend
// i18n dictionaries and the gwapi dictionary both already carry 'it'.
const production = false
const mode = 'NEUTRAL'
const context = 'neutral'

// served behind nginx : call the backend same-origin under /api (proxied to gwapi)
const apiEndpoint = '/api'

// selects the demo city profile (map centre, brand, datasets) — see @core/city-profile
const demoCity = 'torino'

// demo runs in Italian, centred on Turin
const lang = 'it'
const geo = 'it'
const locale = `${lang}-${geo}`
const tz = 'Europe/Rome'
const timezone = tz

// authentication is REQUIRED at connection (same as the other demo builds)
const demoBypassAuth = false

// auto-login credentials, used ONLY when demoBypassAuth is true (no-op here)
const demoAccount = 'admin'
const demoPassword = 'demotorino2026'

export const environment = { ...env, production, mode, context, apiEndpoint, demoCity, lang, geo, locale, tz, timezone, demoBypassAuth, demoAccount, demoPassword }
